import Phoneimg from "../../../assests/solutionImages/EventQr/Phoneimg.svg";
import callicon from "../../../assests/solutionImages/EventQr/Callicon.svg";

function EventQrTheme({ card }) {
  // console.log(card);
  
  // Extract data from card or use fallback values
  const cardData = card?.data || {};
  
  const eventData = {
    backgroundImageUrl: card?.backgroundImage || null,
    organizer: cardData.organizer || "Boiler Room",
    eventName: cardData.eventName || "Amazing Tech Fest 2025",
    summary: cardData.summary || "Join us for an immersive tech experience!",
    buttonLabel: cardData.buttonLabel || "Buy Tickets",
    buttonLink: cardData.buttonLink || "#",
    eventDateFrom: cardData.eventDateFrom || "2025-07-15T10:00:00Z",
    eventDateTo: cardData.eventDateTo || "2025-07-15T17:00:00Z",
    venue: cardData.venue || "Tech Convention Center",
    address: cardData.address || "123 Silicon Valley, CA",
    title: cardData.title || "Agenda",
    description: cardData.description || "Keynotes, panels, and networking sessions.",
    contactTitle: cardData.contactTitle || "Contacts",
    contactNumber: {
      label: cardData.contactNumber?.label || "Call Us",
      number: cardData.contactNumber?.number || "+91 9823474374"
    },
    contactEmail: {
      label: cardData.contactEmail?.label || "E-mail",
      email: cardData.contactEmail?.email || "contactme@gmail.com"
    },
    contactAddress: {
      label: cardData.contactAddress?.label || "Permanent Address",
      line1: cardData.contactAddress?.line1 || "4517 Washington Ave.",
      line2: cardData.contactAddress?.line2 || "",
      city: cardData.contactAddress?.city || "Manchester",
      state: cardData.contactAddress?.state || "Kentucky",
      country: cardData.contactAddress?.country || "USA",
      zipCode: cardData.contactAddress?.zipCode || "39495",
      hasActionButton: cardData.contactAddress?.hasActionButton || false,
      directionText: cardData.contactAddress?.directionText || "",
      googleMapUrl: cardData.contactAddress?.googleMapUrl || ""
    }
  };

  // Web links data - can be extended to come from card data if needed
  // const links = [
  //   {
  //     title: "Title 1",
  //     description: "Visit for more information",
  //     url: "#"
  //   },
  //   {
  //     title: "Title 2", 
  //     description: "Learn more on our website",
  //     url: "#"
  //   }
  // ];

  const formatDate = (dateString) => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const getDateRange = () => {
    const { eventDateFrom, eventDateTo } = eventData;
    if (eventDateFrom && eventDateTo) {
      return `${formatDate(eventDateFrom)} - ${formatDate(eventDateTo)}`;
    } else if (eventDateFrom) {
      return formatDate(eventDateFrom);
    }
    return "Event Date";
  };

  const handleButtonClick = () => {
    if (eventData.buttonLink && eventData.buttonLink !== "#") {
      window.open(eventData.buttonLink, "_blank");
    }
  };

  const handleAddressClick = () => {
    if (eventData.contactAddress.googleMapUrl) {
      window.open(eventData.contactAddress.googleMapUrl, "_blank");
    }
  };

  const formatAddress = () => {
    const { line1, line2, city, state, country, zipCode } = eventData.contactAddress;
    return [line1, line2, city, state, country, zipCode]
      .filter(Boolean)
      .join(", ");
  };

  // Check if contact info should be displayed
  const hasContactInfo = () => {
    return eventData.contactNumber.number || 
           eventData.contactEmail.email || 
           eventData.contactAddress.line1;
  };

  return (
    <div className="flex justify-center bg-gray-400 min-h-screen p-2 md:py-4">
      <div className="flex flex-col max-w-[393px] rounded-lg text-white space-y-6 overflow-y-auto scrollbar-hide">
        <div className="w-full bg-[#262626] rounded-lg">
          {/* Event Banner */}
          {eventData.backgroundImageUrl ? (
            <img
              src={eventData.backgroundImageUrl}
              alt="Event Background"
              className="rounded-t-lg w-full h-44 object-cover"
            />
          ) : (
            <img
              src={Phoneimg}
              alt="Default Background"
              className="rounded-t-lg w-full h-44 object-cover"
            />
          )}

          {/* Event Header */}
          <div className="w-full px-4">
            <h1 className="text-2xl font-bold text-center text-white mt-4 break-words">
              {eventData.eventName}
            </h1>
            {eventData.summary && (
              <p className="text-center py-2 text-sm text-[#CCCCCC] break-words">
                {eventData.summary}
              </p>
            )}
            {eventData.buttonLabel && (
              <div className="flex justify-center items-center py-5">
                <button 
                  className="px-10 py-4 bg-[#8F0145] hover:bg-[#8F0140] text-white rounded-xl transition-colors cursor-pointer break-words"
                  onClick={handleButtonClick}
                >
                  {eventData.buttonLabel}
                </button>
              </div>
            )}
          </div>

          {/* Event Info */}
          <div className="bg-[#232323] mx-4 mb-4 p-4 rounded-xl text-sm divide-y divide-[#444444]">
            {eventData.organizer && (
              <div className="grid grid-cols-2 py-4">
                <span className="text-[#999999] break-words">Host Name</span>
                <span className="break-words text-right">{eventData.organizer}</span>
              </div>
            )}
            <div className="grid grid-cols-2 py-4">
              <span className="text-[#999999] break-words">Date/Time</span>
              <span className="break-words">{getDateRange()}</span>
            </div>
            {eventData.venue && (
              <div className="grid grid-cols-2 py-4">
                <span className="text-[#999999] break-words">Venue</span>
                <span className="text-right break-words">{eventData.venue}</span>
              </div>
            )}
            {eventData.address && (
              <div className="grid grid-cols-2 py-4">
                <span className="text-[#999999] break-words">Address</span>
                <span className="text-right break-words">{eventData.address}</span>
              </div>
            )}
            {eventData.summary && (
              <div className="grid grid-cols-2 py-4">
                <span className="text-[#999999] break-words">Summary</span>
                <span className="text-right break-words">{eventData.summary}</span>
              </div>
            )}
          </div>

          {/* Contact Info - Only show if there's contact information */}
          {hasContactInfo() && (
            <div className="bg-[#232323] mx-4 mb-4 p-4 rounded-xl text-sm">
              <div className="flex gap-4 items-center mb-4">
                <img src={callicon} alt="Call icon" className="w-6 h-6" />
                <h2 className="text-xl font-semibold text-[#D9D9D9] break-words">
                  {eventData.contactTitle || "Contact Info"}
                </h2>
              </div>
              <div className="divide-y divide-[#444444]">
                {eventData.contactNumber.number && (
                  <div className="py-4">
                    <p className="text-[#999999] break-words">
                      {eventData.contactNumber.label || "Phone"}
                    </p>
                    <a 
                      href={`tel:${eventData.contactNumber.number}`}
                      className="text-white font-medium hover:text-[#8F0145] transition-colors break-words"
                    >
                      {eventData.contactNumber.number}
                    </a>
                  </div>
                )}
                {eventData.contactEmail.email && (
                  <div className="py-4">
                    <p className="text-[#999999] break-words">
                      {eventData.contactEmail.label || "Email"}
                    </p>
                    <a 
                      href={`mailto:${eventData.contactEmail.email}`}
                      className="text-white font-medium hover:text-[#8F0145] transition-colors break-words"
                    >
                      {eventData.contactEmail.email}
                    </a>
                  </div>
                )}
                {eventData.contactAddress.line1 && (
                  <div className="py-4">
                    <p className="text-[#999999] break-words">
                      {eventData.contactAddress.label || "Address"}
                    </p>
                    <div className="flex items-start justify-between">
                      <p className="text-white font-medium flex-1 break-words">
                        {formatAddress()}
                      </p>
                      {eventData.contactAddress.hasActionButton && eventData.contactAddress.googleMapUrl && (
                        <button
                          onClick={handleAddressClick}
                          className="ml-2 px-3 py-1 bg-[#8F0145] hover:bg-[#8F0140] text-white text-xs rounded transition-colors break-words"
                        >
                          {eventData.contactAddress.directionText || "Directions"}
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Web Links - Currently using static data, can be made dynamic if needed */}
          {/* {links.length > 0 && (
            <div className="bg-[#232323] text-white mx-4 mb-4 p-4 rounded-xl">
              <h2 className="text-xl font-semibold mb-2 text-custom-gradient">
                {eventData.title || "Web Links"}
              </h2>
              {eventData.description && (
                <p className="text-xs text-[#999999] mb-2">{eventData.description}</p>
              )}
              {links.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between py-3 hover:bg-[#2f2f2f] rounded-md transition-colors"
                >
                  <div className="flex items-center gap-4">
                    <div className="h-10 w-10 flex items-center justify-center">
                      <img src={LinkIcon} className="w-full h-full" alt="link" />
                    </div>
                    <div>
                      <p className="font-bold text-custom-gradient">{link.title}</p>
                      <p className="text-sm text-gray-400">{link.description}</p>
                    </div>
                  </div>
                  <MdChevronRight size={24} className="text-gray-500" />
                </a>
              ))}
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default EventQrTheme;
